import { combineReducers } from 'redux'

import authReducer from './auth'
import lotsReducer from './lots'
import newsReducer from './news'
import fundsReducer from './funds'
import personsReducer from './persons'
import contactsReducer from './contacts'
import commentsReducer from './comments'
import localesReducer from './i18n'
import { intlReducer } from 'react-intl-redux'
import actionsReducer from './actions'
//
import home from './home'
import doc from './static'
import login from './login'
import about from './about'
import search from './search'
import payment from './payment'
import partners from './partners'
import feedback from './feedback'
import countries from './countries'
import categories from './categories'
import profile from './profile/index'
import paymentMethods from './paymentMethods'
import checkout from './checkout'
import externalpartners from './externalpartners'
import externalpayments from './externalpayments'

export default asyncReducers => combineReducers({
  auth: authReducer,
  lots: lotsReducer,
  news: newsReducer,
  funds: fundsReducer,
  contacts: contactsReducer,
  comments: commentsReducer,
  persons: personsReducer,
  intl: intlReducer,
  locales: localesReducer,
  actions: actionsReducer,
  //
  doc,
  home,
  about,
  login,
  search,
  payment,
  profile,
  partners,
  feedback,
  countries,
  categories,
  paymentMethods,
  checkout,
  externalpartners,
	externalpayments,
  //
  // ...asyncReducers
})



// WEBPACK FOOTER //
// ./src/store/reducers/index.js